import { ReactNode } from "react";

import { ParagraphTag } from "@smart/itops-serialisation-basic";

import { headingClassNames } from "../elements/paragraph";

export type DisplayParagraphProps = {
  Tag?: ParagraphTag;
  headingStyled?: boolean;
  children: ReactNode;
};

export const DisplayParagraph = ({
  children,
  Tag = "p",
  headingStyled,
}: DisplayParagraphProps) => (
  <Tag
    className={
      headingStyled && Tag !== "p" && Tag !== "span"
        ? headingClassNames[Tag]
        : undefined
    }
  >
    {children}
  </Tag>
);
